import { Flex, FormControl, useToast } from '@chakra-ui/react'
import { useState } from 'react'
import { FaPlus, FaTrash } from 'react-icons/fa'
import { ButtonCmp } from '../../../../../../components/ButtonCmp'
import { iConvite } from '../../../../../../interfaces'
import { appApi } from '../../../../../../services/appApi'
import { ModalBase } from '../../../../../../components/ModalBase'
import { TableConvites } from '../Tabela'
import { PropInvalida } from '../../../../../../Utils/Helper'
import { InputCmp } from '../../../../../../components/InputCmp'

interface iModalProps {
  isOpen: boolean
  reaberto: boolean
  rows: iConvite[]
  paramId: string
  onInterromper: (email: string) => void
  onReabrir: (email: string) => void
  Reload: () => void
  onClose: () => void
}
export const ModalConviteEmail: React.FC<iModalProps> = ({ isOpen, rows, paramId, onClose, Reload, reaberto, onInterromper, onReabrir }) => {
  const toast = useToast()
  const [Selecionados, setSelecionados] = useState<string[]>([])
  const [Email, setEmail] = useState('')

  function onCheck(ids: string[], all?: boolean): void {
    if (!PropInvalida(all)) {
      if (all) {
        if (rows.some(r => r.convitesExtras)) {
          const idsAll: string[] = []
          rows.filter(e => !e.etapaVinculada).forEach(e => {
            if (e.convitesExtras) {
              e.convitesExtras.forEach(id => {
                idsAll.push(id)
              })
            }
          })
          setSelecionados(idsAll)
        } else {
          setSelecionados(Selecionados.concat(rows.filter(r => !r.etapaVinculada && !Selecionados.some(t => t === r.id)).map((e) => { return e.id })))
        }
      } else {
        setSelecionados([])
      }
    } else {
      let copy = [...Selecionados]
      if (!ids.every(e => copy.includes(e))) {
        copy = copy.concat(ids.filter(id => !copy.includes(id)))
        setSelecionados(copy)
      } else {
        setSelecionados([])
        const filtrado = copy.filter(e => !ids.includes(e))
        setSelecionados(filtrado)
      }
    }
  }

  function onDeleteConvites(): void {
    appApi.post('PesquisaInternaConvite/DeletarVarios', Selecionados)
      .then(() => {
        Reload()
        setSelecionados([])
      })
      .catch(err => console.log(err))
  }

  function CadastrarPorEmail(): void {
    appApi.post(`PesquisaInternaConvite/${paramId}/Email`, { texto: Email })
      .then((res) => {
        Reload()
        if (res.data === 'Colaborador inativo') {
          toast({
            title: res.data,
            position: 'top',
            duration: 4000,
            status: 'error'
          })
        }
      })
      .catch(err => { console.log(err) })
  }

  return (
    <ModalBase
      Titulo="Convite por e-mail"
      Subtitulo="Utilize os filtros para selecionar apenas os convites que desejar. Você pode filtrar por área ou nome. Poderá também clicar na barra de seleção e adicionar todos os convites que estão aparecendo na lista a partir dos filtros realizados."
      isOpen={isOpen}
      onClose={onClose}
      Width='52rem'
    >
      <Flex padding={'0 1rem 1rem 1rem'} flexDir={'column'}>
        <Flex width={'100%'} marginBottom={'1rem'} gap={'.5rem'} alignItems={'end'}>
          <FormControl as={Flex} alignItems={'center'}>
            <InputCmp
              label='Email'
              OnChange={setEmail}
              placeholder='Colaborador@gmail.com'
            />
          </FormControl>
          <ButtonCmp w={'11rem'} VarColor='Rosa' leftIcon={<FaPlus/>} onClick={CadastrarPorEmail}>Adicionar email</ButtonCmp>
        </Flex>

        {
          (rows !== undefined && rows.filter(e => e.convitesExtras ?? e.status !== 'Respondido').length > 0) && (
            <>
              <Flex marginBottom={'1rem'} fontWeight={'400'} justifyContent={'space-between'} alignItems={'center'}>
                <h3>Usuários selecionados</h3>
                <ButtonCmp leftIcon={<FaTrash />} VarColor={'terc3'} onClick={onDeleteConvites}>Excluir convites selecionados</ButtonCmp>
              </Flex>
              <TableConvites
                isEdit
                rows={rows.filter(e => e.convitesExtras ?? e.status !== 'Respondido')}
                onCheck={onCheck}
                selecionados={Selecionados}
                reaberto={reaberto}
                onReabrir={onReabrir}
                onInterromper={onInterromper}
                onSend={() => { }}
              />
            </>
          )
        }
      </Flex>
      <Flex padding={'0 1rem 1rem 0'} justifyContent={'end'}>
        <ButtonCmp VarColor='Green2' onClick={onClose}>Continuar</ButtonCmp>
      </Flex>
    </ModalBase>
  )
}
